type SanitizeFilenameComponentArgs = {
  noteTitle?: string | null;
};

export const sanitizeFilenameComponent = ({
  noteTitle,
}: SanitizeFilenameComponentArgs): string | null => {
  if (!noteTitle) return null;
  const sanitized = noteTitle
    .replace(/[<>:"/\\|?*]/g, "-")
    .replace(/\s+/g, " ")
    .trim()
    .slice(0, 200);
  return sanitized || null;
};

type BuildAudioRecordingDownloadFileNameArgs = {
  noteTitle?: string | null;
  extension: string;
};

export const buildAudioRecordingDownloadFileName = ({
  noteTitle,
  extension,
}: BuildAudioRecordingDownloadFileNameArgs): string => {
  const sanitizedTitle = sanitizeFilenameComponent({ noteTitle }) ?? "Untitled Note";
  return `${sanitizedTitle} - Voice Recording.${extension}`;
};
